import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  // NOTE: JWT bearer is stored in localStorage on purpose — this is the pattern
  // documented in the Emergent Auth playbook (cookie session_token for OAuth,
  // localStorage bearer for the classic email/password login). Do not "harden"
  // this to cookies-only or the login flow breaks.
  const token = localStorage.getItem("proxijob_token");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});
